'use client';

import Link from 'next/link';

import { useTheme } from '@/components/theme-provider';

interface LogoProps {
  className?: string;
}

export function HorizontalLogo({ className }: LogoProps) {
  const { theme } = useTheme();

  // Define dynamic classes based on theme
  const primaryFill = theme === 'dark' ? 'fill-white' : 'fill-[#222]';
  const secondaryFill = theme === 'dark' ? 'fill-gray-200' : 'fill-black';

  return (
    <Link href="/">
      <svg
        width="90"
        height="38"
        viewBox="0 0 90.38 38.4"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <g>
              <path
                className={primaryFill}
                d="M19.57.02c.7-.14,1.4.58,1.37,1.27v36.05c-.13.73-.89,1.24-1.62,1s-.81-.96-.86-1.62c-.46-6.11.36-12.82,0-18.95.04-5.53.16-11.05.1-16.59-.02-.39.67-1.1,1.01-1.16Z"
              />
              <path
                className={primaryFill}
                d="M23.58.33c.86-.26,1.5.32,1.58,1.16.4,4.31-.31,9.23,0,13.6-.16,5.3-.16,10.65-.11,15.96.02,1.89.33,3.98.11,5.87-.14,1.21-1.98,1.72-2.43.36l-.05-35.59c-.07-.39.59-1.27.9-1.36Z"
              />
              <path
                className={primaryFill}
                d="M15.14.33c.79-.18,1.51.37,1.58,1.16.39,4.21-.3,9.02,0,13.29-.4,6.94.31,14.09-.11,21.01-.05.85.24,2.25-1.09,2.31-1.69.07-1.28-3.08-1.28-4.17-.05-7.37.05-14.84.11-22.24.03-3.21-.27-6.98,0-10.1.04-.51.21-1.13.8-1.26Z"
              />
              <path
                className={primaryFill}
                d="M10.66,36.53c-.76-.62-.56-3.17-.55-4.15.02-1.27.01-2.53,0-3.8-.03-2.6.77-6.04-2.42-6.95l-6.95-.16c-.98-.5-.97-1.67-.1-2.27l7.85-.03c3.17.89,3.96,2.93,4.1,5.99-.25,3.3.32,7.06,0,10.3-.09.88-.5,1.24-1.39,1.19-.18,0-.38-.01-.53-.14Z"
              />
              <path
                className={primaryFill}
                d="M37.39,19.08c.35,0,1.3.07,1.56.24.66.43.48,1.85-.23,2.13-.23.09-1.24.17-1.57.19-1.69.09-3.98-.24-5.56,0-1.33.2-2.32,1.43-2.43,2.72-.31,3.55.33,7.43.1,11.01-.22,1.56-2.45,1.93-2.47.12.21-3.87-.27-8.01,0-11.85.17-2.48,2.38-4.3,4.79-4.48,1.7-.13,4.08-.1,5.8-.08Z"
              />
              <path
                className={primaryFill}
                d="M9.47,13.56c.46-.51.7-1.5.75-2.18.22-2.67-.36-6.07.03-8.62.21-1.42,2.18-1.54,2.34-.13-.42,3.02.72,8.6-.36,11.27-1.82,4.49-7.29,3.09-11.1,3.28-1.16-.45-1.02-2.2.21-2.43,2.36-.43,6.33.83,8.13-1.19Z"
              />
              <path
                className={primaryFill}
                d="M28.83,1.78c.21.19.41.76.44,1.05.31,2.79-.28,6.14,0,8.96.09.89.77,1.91,1.53,2.38,1,.62,2.6.62,3.77.66,1.3.05,2.6-.06,3.9.02,1.11.87.8,2.22-.7,2.35-1.92.16-6.28.2-7.94-.62-2.66-1.31-3.08-3.5-3.04-6.24.04-2.39.14-4.8.11-7.21,0-.36-.25-.71.03-1.05.4-.5,1.37-.78,1.89-.31Z"
              />
              <path
                className={primaryFill}
                d="M1.34,23.5c2.07.1,4.13-.55,5.85.91.78.67,1.22,1.81,1.29,2.83.15,2.02-.08,4.3-.06,6.34-.5.61-1.42.76-1.95.1-1.33-1.67.58-6.05-1.39-7.47-1.06-.76-3.54.45-4.27-1.09-.3-.64-.13-1.31.53-1.62Z"
              />
              <path
                className={primaryFill}
                d="M34.3,23.51c.72-.07,3.19-.14,3.76.09.61.25.69.84.56,1.45-.15.74-.81.85-1.47.9-1.35.11-3.41-.54-3.92,1.13s.51,5.06-.38,6.42c-.32.49-.78.63-1.35.46-.51-.15-.65-1.13-.69-1.58-.1-1.21-.17-5.36.11-6.38.4-1.48,1.93-2.35,3.37-2.5Z"
              />
              <path
                className={primaryFill}
                d="M7,4.45c1.14-.26,1.47.67,1.56,1.59.14,1.45.19,4.5-.97,5.5-1.32,1.14-2.93,1.34-4.64,1.14-1.37-.16-1.29-2.33-.28-2.56s2.72.28,3.19-1.03c.43-1.18-.49-4.27,1.13-4.63Z"
              />
              <path
                className={primaryFill}
                d="M31.89,11.6c-1.77-1.83-.75-4.35-.96-6.6.15-.78,2.21-1.05,2.37.61.1,1.03-.22,2.5.18,3.42.64,1.47,1.74.81,2.96.96,1.32.16,1.53,2.5,0,2.68s-3.45.07-4.55-1.07Z"
              />
              <path
                className={primaryFill}
                d="M34.87,28.04c.33-.4,1.18-.79,1.69-.57,1.3.56.51,2.91-.85,2.89-1.1-.02-1.46-1.57-.84-2.32Z"
              />
              <path
                className={primaryFill}
                d="M3.09,27.42c1.75-.52,2.71,3.21.49,2.97-.64-.07-1.2-.99-1.19-1.6,0-.37.32-1.26.7-1.37Z"
              />
            </g>
            <g>
              <g>
                <path
                  className={secondaryFill}
                  d="M54.37,29.86v-4.45c0-.31.18-.49.53-.49h1.77c1.35,0,2.01.7,2.01,1.56,0,.5-.31.96-.74,1.16.6.21.89.71.89,1.19,0,.89-.7,1.52-1.99,1.52h-1.95c-.35,0-.53-.19-.53-.49ZM56.65,27.26c.53,0,.82-.24.82-.64s-.31-.64-.86-.64h-.91c-.13,0-.19.05-.19.22v1.05h1.13ZM55.71,29.29h1.08c.59,0,.82-.23.82-.59,0-.32-.25-.55-.73-.55h-1.35v.92c0,.17.06.22.19.22Z"
                />
                <path
                  className={secondaryFill}
                  d="M63.87,28.38l1.06,1.08c.11.12.18.26.18.4,0,.29-.26.56-.59.56-.19,0-.32-.07-.43-.2l-1.53-1.65h-.82v1.35c0,.3-.25.49-.58.49s-.58-.2-.58-.49v-4.51c0-.31.18-.49.53-.49h1.7c1.63,0,2.28.87,2.28,1.73,0,.64-.35,1.4-1.23,1.72ZM62.74,27.55c.82,0,1.06-.39,1.06-.79s-.24-.77-1.06-.77h-.81c-.13,0-.19.05-.19.22v1.34h1Z"
                />
                <path
                  className={secondaryFill}
                  d="M67.95,29.14l-.32.83c-.11.3-.31.45-.58.45-.33,0-.58-.22-.6-.53,0-.12.02-.24.07-.36l1.54-3.85c.25-.61.57-.79,1.03-.79h.07c.46,0,.78.18,1.02.79l1.57,3.84c.06.13.08.26.08.33,0,.35-.29.57-.63.57-.26,0-.47-.16-.59-.45l-.31-.82h-2.37ZM69.92,28.1l-.78-2.08h-.02l-.79,2.08h1.59Z"
                />
                <path
                  className={secondaryFill}
                  d="M73.19,25.04c0-.41.35-.75.77-.75s.76.34.76.75-.34.75-.76.75-.77-.33-.77-.75ZM73.36,26.86c0-.32.25-.52.6-.52s.6.2.6.52v3.01c0,.33-.25.53-.6.53s-.6-.2-.6-.53v-3.01Z"
                />
                <path
                  className={secondaryFill}
                  d="M80.78,30.41h-.03c-.33,0-.55-.13-.8-.48l-2.24-3.17v3.16c0,.3-.25.49-.58.49s-.58-.2-.58-.49v-4.4c0-.37.26-.65.62-.65h.05c.32,0,.53.1.87.58l2.23,3.02v-3.11c0-.3.25-.49.58-.49s.58.2.58.49v4.48c0,.34-.35.57-.69.57Z"
                />
              </g>
              <g>
                <path
                  className={secondaryFill}
                  d="M51.6,15.65l1.99,2.03c.2.22.34.48.34.74,0,.54-.48,1.05-1.1,1.05-.36,0-.6-.12-.8-.37l-2.86-3.09h-1.55v2.54c0,.56-.46.93-1.08.93s-1.08-.37-1.08-.93v-8.46c0-.57.34-.91.99-.91h3.19c3.06,0,4.27,1.64,4.27,3.25,0,1.19-.66,2.63-2.3,3.23ZM49.49,14.09c1.55,0,1.99-.73,1.99-1.48s-.45-1.44-1.99-1.44h-1.52c-.25,0-.36.09-.36.42v2.5h1.87Z"
                />
                <path
                  className={secondaryFill}
                  d="M62.28,17.35h4.38c.59,0,.99.39.99,1.01s-.4.99-.99.99h-5.88c-.6,0-1.02-.37-1.02-.99v-8.18c0-.62.42-1.01,1.02-1.01h5.78c.59,0,.99.39.99,1.01s-.4.99-.99.99h-4.28c-.25,0-.36.09-.36.42v1.7h3.23c.59,0,.97.37.97.97s-.39.96-.97.96h-3.23v1.72c0,.32.11.42.36.42Z"
                />
                <path
                  className={secondaryFill}
                  d="M75.21,17.07l-.6,1.56c-.2.56-.57.83-1.08.83-.62,0-1.08-.42-1.13-.99-.02-.22.05-.45.14-.68l2.89-7.22c.46-1.14,1.07-1.48,1.93-1.48h.14c.87,0,1.47.34,1.92,1.48l2.94,7.21c.11.25.15.48.15.62,0,.65-.54,1.07-1.18,1.07-.48,0-.88-.29-1.1-.85l-.59-1.55h-4.44ZM78.91,15.12l-1.45-3.9h-.05l-1.48,3.9h2.98Z"
                />
                <path
                  className={secondaryFill}
                  d="M87.52,9.39c0-.77.65-1.41,1.44-1.41s1.42.63,1.42,1.41-.63,1.41-1.42,1.41-1.44-.62-1.44-1.41ZM87.83,12.8c0-.6.46-.97,1.13-.97s1.13.37,1.13.97v5.64c0,.62-.46.99-1.13.99s-1.13-.37-1.13-.99v-5.64Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Link>
  );
}
